import { Box, Table, TableRow, TableBody, TableCell, TableContainer, Typography, useTheme, Button, IconButton } from '@mui/material'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import React, { useEffect, useMemo, useState } from 'react'

import { formatDateTimeForDisplay } from '../../utils/exam-utilities'
import noExamImg from '../../assets/noexams.svg'
import TableHeader from '../common/TableHeader'
import CodeButton from '../common/CodeButton'
import { formatDate, Icons } from '../../utils/utilities'
import CustomChip from '../common/CustomChip'
import CustomTable from '../common/custom-table/CustomTable'
import dayjs from 'dayjs'


export default function ListView ( { exams, userRole, isAuditing } ) {


    const [searchParams, setSearchParams] = useSearchParams( { searchText: "" } )
    const searchText = searchParams.get( 'searchText' )

    const navigate = useNavigate()
    const { palette, border, table } = useTheme()

    const columns = useMemo( () => ( [
        { id: 0, name: "Sl.no", field: "index", index: true, align: "center", rowPadding: "10px 20px" },
        { id: 1, name: "Title", linkGetter: row => `/${userRole === "STUDENT" ? "student" : "faculty"}/exams/${row.exam_id}`, field: "exam_name", width: "200px" },
        { id: 3, name: "Subject", field: "subject", renderCell: row => ( row?.subject?.subject_name?.toLowerCase() || "-" )?.trim(), width: "200px", cellStyles: { textTransform: "capitalize" } },
        { id: 2, name: "Exam Date", field: "exam_start_date", renderCell: row => formatDate( row.exam_start_date ), width: "120px" },
        // { id: 6, hide: userRole !== "STUDENT", name: "Best Score", field: "best_score", renderCell: row => <CustomChip variant='filled' color="primary" value={`${row.best_score || 0}/${row.total_marks}`} />, width: "120px", align: "center" },
        { id: 7, hide: userRole === "STUDENT", name: "Participations", field: "exam_participations", renderCell: row => formatDate( row.exam_start_date ), width: "120px" },
        { id: 5, hide: userRole === "STUDENT", name: "Status", align: "right", renderCell: row => ( <CustomChip color={row.exam_status === 'Draft' ? "error" : "success"} variant={row.exam_status === "Draft" ? "filled" : "outlined"} value={row.exam_status?.toUpperCase()} /> ) },
        {
            id: 2, name: "Actions", align: "right", field: "actions", renderCell: row => (
                <Box display="flex" alignItems='center' justifyContent="flex-end" gap="5px">
                    <Button endIcon={Icons.default.ArrowOutward} color='primary' size='small' sx={{ textTransform: "capitalize" }} component={Link} to={`/${userRole === "STUDENT" ? "student" : "faculty"}/exams/${row.exam_id}`} disabled={isAuditing}>
                        View Exam
                    </Button>
                    {userRole === "STUDENT" && dayjs( `${row.exam_end_date.split( "T" )[0]} ${row.exam_end_time}` ).isBefore( dayjs() ) && <IconButton color='greyed' size='small' component={Link} to={`/student/scores/${row.exam_id}/${row.participation_id}`} disabled={isAuditing}>
                        {Icons.default.AnalyticsIcon}
                    </IconButton>}
                    {userRole !== "STUDENT" && <IconButton color='greyed' size='small' component={Link} to={`/faculty/exams/${row.exam_id}/participation`} disabled={isAuditing}>
                        {Icons.default.AnalyticsIcon}
                    </IconButton>}
                </Box>
            ), width: "200px"
        },
    ] ), [userRole, isAuditing] )

    const navigateToExam = exam => {
        navigate( `/${userRole === "STUDENT" ? "student" : "faculty"}/exams/${exam.exam_id}` )
    }

    const removeFilter = () => {
        setSearchParams( prev => {
            prev.set( 'searchText', "" )
            return prev
        }, { replace: true } )
    }

    const filterFunc = item => {
        const searchRegexp = new RegExp( searchText?.replace( /[.*+?^${}()|[\]\\]/g, '\\$&' ), 'i' )
        return item.exam_name.match( searchRegexp )
    }

    return (
        <Box display="flex" flexGrow={1} border={border[1]} borderRadius="5px" flexDirection="column" overflow="auto" >
            {exams.length > 0 && exams.filter( filterFunc ).length !== 0 &&
                <CustomTable dataIdKey="exam_id" containerStyles={{ maxHeight: "550px" }} data={exams} columns={columns} />
            }
            {exams.filter( filterFunc ).length === 0 && <Box flexGrow={1} display="flex" padding="20px" flexDirection="column" gap="20px" alignItems="center" justifyContent="center" borderRadius="5px" bgcolor={palette.contentBg}>
                <Box component="img" src={noExamImg} width="200px" alt="no exams!" />
                <Typography variant='subtitle2'>No results found for <u><em>{searchText}</em></u></Typography>
                <Button onClick={removeFilter} variant="outlined" color="secondary" sx={{ textTransform: "capitalize" }}>Remove filter</Button>
            </Box>}
        </Box >
    )
}
